<template>
  <div>
    <custom-actions :panel="false">
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="addRow">新增</el-button>

      </template>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-tabs v-model="activeName" @tab-click="loadData">
        <el-tab-pane :label="item[1]" :name="item[0]" v-for="(item, index) of Array.from(planTypeMap)" :key="index"></el-tab-pane>
      </el-tabs>
      <el-table size="mini" stripe border :data="timeSlots">
        <el-table-column min-width="120" label="开始时间" prop="startTime"></el-table-column>
        <el-table-column min-width="120" label="结束时间" prop="endTime"></el-table-column>
        <el-table-column min-width="120" label="是否当日" prop="isDay">
          <template v-slot="{ row }">
            {{ row.isDay === '1' ? '当日' : '次日' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="是否可约饭" prop="isMeal">
          <template v-slot="{ row }">
            {{ isMealMap.get(row.isMeal) || '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" label="时间排序" prop="timeSort"></el-table-column>

        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" v-if="hasEdit" @click="editRow(row)">编辑</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.slotId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="时间段配置" class="global-dialog" :visible.sync="showDlg" width="400px" :before-close="handleClose">
      <div class="dlg-content">
        <el-form class="global-form" :key="formData.slotId || '123'" style="padding:30px 40px 20px 20px;"
          :model="formData" :rules="rules" ref="form" label-width="100px">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="planType" label="计划类型">
                <el-select v-model="formData.planType" placeholder="请选择">
                  <el-option v-for="(item, index) of Array.from(planTypeMap)" :label="item[1]" :value="item[0]"
                    :key="index" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="startTime" label="开始时间">
                <el-time-select v-model="formData.startTime"
                  :picker-options="{ start: '00:00', end: '24:00', format: 'HH:mm', step: '00:05' }"
                  value-format="HH:mm" placeholder="选择时间"></el-time-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="endTime" label="结束时间">
                <el-time-select v-model="formData.endTime"
                  :picker-options="{ start: '00:00', end: '24:00', format: 'HH:mm', step: '00:05', minTime: formData.startTime }"
                  value-format="HH:mm" placeholder="选择时间">
                </el-time-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="isDay" label="是否当日">
                <el-radio-group v-model="formData.isDay">
                  <el-radio label="1">当日</el-radio>
                  <el-radio label="2">次日</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item prop="isMeal" label="是否可约饭">
                <el-select v-model="formData.isMeal" placeholder="请选择">
                  <el-option v-for="(item, index) of Array.from(isMealMap)" :label="item[1]" :value="item[0]"
                    :key="index" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="timeSort" label="时间排序">
                <el-input v-model="formData.timeSort" placeholder="请输入时间排序"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="saveSlot">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
import { deepClone } from '@/utils/utils'
import { isMeal, planType } from '@/utils/dict'
export default {
  name: 'CarTimeConfig',
  mixins: [keepAlive],
  data() {
    // 获取当前年月日
    const currentDate = this.$dayjs().format('YYYY-MM-DD')

    const validateEndTime = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请选择结束时间'))
      }

      // 验证结束时间是否大于开始时间，添加当前年月日
      if (this.formData.startTime && value) {
        const start = this.$dayjs(`${currentDate} ${this.formData.startTime}`)
        const end = this.$dayjs(`${currentDate} ${value}`)

        if (end.isBefore(start) || end.isSame(start)) {
          return callback(new Error('结束时间必须大于开始时间'))
        }
      }
      callback()
    }
    return {
      activeName: '1',
      showDlg: false,
      timeSlots: [],
      isMealMap: isMeal,
      planTypeMap: planType,
      formData: {
        isMeal: '',
        startTime: '',
        endTime: '',
        isDay: '', // 是否本日，1：本日，2：次日
        timeSort: ''
      },
      rules: {
        planType: [
          { required: true, message: '请选择计划类型' }
        ],
        startTime: [
          { required: true, message: '请选择开始时间' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间' },
          { validator: validateEndTime }
        ],
        isMeal: [
          { required: true, message: '请选择是否可约饭' }
        ],
        isDay: [
          { required: true, message: '请选择是否当日' }
        ]
      }

    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    },
    // 检查当前时间范围是否有效（开始时间早于结束时间）
    isValidTimeRange() {
      // 处理秒数：开始时间秒数为00，结束时间秒数为59
      const processedStart = this.processStartTime(this.formData.startTime)
      const processedEnd = this.processEndTime(this.formData.endTime)
      console.log('processedStart', processedStart)
      console.log('processedEnd', processedEnd)
      const currentDate = this.$dayjs().format('YYYY-MM-DD')
      return this.$dayjs(currentDate + ' ' + processedStart).isBefore(currentDate + ' ' + processedEnd)
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    deleteRow(slotId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.clyy.deleteDataWlVehicleTimeslot, {
          slotId
        }).then(() => {
          this.loadData()
        })
      })
    },
    addRow() {
      this.formData = {
        isMeal: '',
        startTime: '',
        endTime: '',
        isDay: '', // 是否本日，1：本日，2：次日
        timeSort: ''
      }
      this.showDlg = true
    },
    editRow(row) {
      console.log('row', row)
      this.formData = deepClone(row)
      this.showDlg = true
    },
    loadData() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleTimeslotByPage, {
        params: {
          planType: this.activeName
        }
      }).then(res => {
        this.timeSlots = res.list
      })
    },
    // 检查时间段是否冲突
    checkTimeConflict() {
      // 获取当前年月日用于时间比较
      const currentDate = this.$dayjs().format('YYYY-MM-DD')
      const newStart = this.$dayjs(`${currentDate} ${this.formData.startTime}`)
      const newEnd = this.$dayjs(`${currentDate} ${this.formData.endTime}`)

      return this.timeSlots.some((range) => {
        // 编辑时跳过当前正在编辑的项（通过slotId判断）
        if (this.formData.slotId && range.slotId === this.formData.slotId) {
          return false
        }

        const existingStart = this.$dayjs(`${currentDate} ${range.startTime}`)
        const existingEnd = this.$dayjs(`${currentDate} ${range.endTime}`)

        // 检查两个时间段是否交叉
        return (
          (newStart.isAfter(existingStart) && newStart.isBefore(existingEnd)) ||
          (newEnd.isAfter(existingStart) && newEnd.isBefore(existingEnd)) ||
          (newStart.isSame(existingStart) && newEnd.isSame(existingEnd)) ||
          (newStart.isBefore(existingStart) && newEnd.isAfter(existingEnd))
        )
      })
    },

    // 保存时间段
    saveSlot() {
      this.$refs.form.validate().then(() => {
        // 检查是否与现有时间段交叉
        if (this.checkTimeConflict()) {
          this.$message.error('该时间段与已有时间段重叠')
          return
        }
        let url = this.$apis.clyy.insertWlVehicleTimeslot
        if (this.formData.slotId) {
          url = this.$apis.clyy.updateWlVehicleTimeslot
        }
        this.$axios.post(url, this.formData).then(() => {
          this.showDlg = false
          this.loadData()
        })
      })
    },
    // 编辑时间段
    editSlot(index) {
      this.editingIndex = index
      // 编辑时回显原始值（包含秒数，但显示时会被格式化）
      this.formData = { ...this.timeSlots[index] }
      this.errorMessage = ''
    },

    // 删除时间段
    deleteSlot(index) {
      this.timeSlots.splice(index, 1)
      if (this.editingIndex === index) {
        this.resetForm()
      } else if (this.editingIndex > index) {
        this.editingIndex--
      }
    },
    handleClose() {
      this.showDlg = false
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>
